import { useEffect, useState, useRef } from '@wordpress/element';
import Vendor from './vendor';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import AddressSearch from './addresssearch';

mapboxgl.accessToken = 'pk.eyJ1IjoiY29kZW1pcSIsImEiOiJjbHYzZ212N3EwMG92MmtrODhkdjY0N2hwIn0.eD7HeYhnlpSNfXJ-dqxlVw';

export default function VendorSearch({ classification = 'CU' }) {
  const [vendors, setVendors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(10.679319);
  const [lat, setLat] = useState(49.984492);
  const [zoom, setZoom] = useState(6);
  const [markers, setMarkers] = useState({});
  const [searchCenterMarker, setSearchCenterMarker] = useState(null);

  const [filteredVendors, setFilteredVendors] = useState([]);
  const [filter, setFilter] = useState({
    lat: 0,
    lng: 0,
  });

  useEffect(() => {
    loadVendors();
  }, [])

  useEffect(() => {
    filterVendors(vendors, true);
  }, [filter, vendors])

  useEffect(() => {
    if (vendors.length == 0) return;
    initMap();
  }, [vendors]);
  // useEffect(() => {

  // }, [filteredVendors])

  // useEffect(() => {
  //   if (map.current) {
  //     map.current.flyTo({
  //       center: [lng, lat],
  //       zoom: zoom
  //     });
  //   }
  // }, [lng, lat, zoom]);

  async function loadVendors() {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const response = await fetch(`/wp-json/cqvs/v1/vendors?classification=${encodeURIComponent(classification)}`);

    if (!response.ok) {
      // oups! something went wrong
      setIsLoading(false);
      return;
    }

    let newVendors = await response.json();

    setVendors(newVendors);

    setIsLoading(false);
  }

  const initMap = () => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [lng, lat],
      zoom: zoom,
      minZoom: 6,
      maxZoom: 18
    });
    map.current.on('move', () => {
      setLng(map.current.getCenter().lng.toFixed(4));
      setLat(map.current.getCenter().lat.toFixed(4));
      setZoom(map.current.getZoom().toFixed(2));
    });
    map.current.on('load', () => {
      // Add navigation control (the +/- zoom buttons)
      //map.current.addControl(new mapboxgl.NavigationControl(), 'top-right');
      const newMarkers = {};
      // create markers from vendors
      vendors.forEach((vendor) => {
        // console.log("add marker for ", vendor);
        newMarkers[vendor.id] = new mapboxgl.Marker({ color: '#009BB4', scale: 0.5 })
          .setLngLat([vendor.lng, vendor.lat])
          .setPopup(new mapboxgl.Popup({ offset: 25 }) // add popups
            .setHTML(getVendorMarkerHTML(vendor))
          )
          .addTo(map.current);
      });
      setMarkers(newMarkers);
    });
  }

  const getVendorMarkerHTML = (vendor) => {
    return "<p class='vendor-title'>" + vendor.title + "</p>\
      <div class='vendor-address'>\
        <p>" + vendor.street + "\
          <br />" + vendor.zipcode + " " + vendor.city + "\
        </p>\
      </div>\
      <div class='vendor-contact'>"
      + (
        vendor.email && "\
          <a class='email' href='mailto:" + vendor.email + "'>\
            " + '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280 320-200v-80L480-520 160-720v80l320 200Z" /></svg>' + "\
            E-MAIL\
          </a>"
      )
      + (
        vendor.url && "\
          <a class='url' href='" + vendor.url + "'>\
            " + '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z" /></svg>' + "\
            WEBSITE\
          </a>"
      )
      // + (
      //   vendor.phone && "\
      //     <a class='phone' href='tel:" + vendor.phone + "'>\
      //       " + '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12Z" /></svg>' + "\
      //       " + vendor.phone + "\
      //     </a>"
      // )
      + ("\
          <a href='https://www.google.com/maps/dir/?api=1&destination=" + vendor.lat + "," + vendor.lng + "' target='_blank' rel='noopener noreferrer' class='navigate'>\
            " + '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M320-360h80v-120h140v100l140-140-140-140v100H360q-17 0-28.5 11.5T320-520v160ZM480-80q-15 0-29.5-6T424-104L104-424q-12-12-18-26.5T80-480q0-15 6-29.5t18-26.5l320-320q12-12 26.5-18t29.5-6q15 0 29.5 6t26.5 18l320 320q12 12 18 26.5t6 29.5q0 15-6 29.5T856-424L536-104q-12 12-26.5 18T480-80ZM320-320l160 160 320-320-320-320-320 320 160 160Zm160-160Z"/></svg>' + "\
            Route planen\
          </a>"
      )
      + ("\
          <div class='cta-wrap'>\
            <a href='/probefahrt/?vendor=" + vendor.id + "&classification=" + classification + "' rel='noopener noreferrer' class='testdrive'>\
            " + '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M480-480Zm80 240q100 0 170-70t70-170q0-101-73.5-170.5T550-720q-48 0-93 11t-87 33l100 40q41 17 65.5 52.5T560-504q0 60-41.5 102T418-360H162q-2 24-2 54.5v65.5h400ZM176-440h240q27 0 45.5-18.5T480-504q0-19-10.5-34.5T440-562l-148-60q-42 37-71.5 84T176-440Zm384 280H160q-33 0-56.5-23.5T80-240v-90q0-98 37-183.5t100.5-149Q281-726 367-763t183-37q68 0 128 25t105 68.5Q828-663 854-605t26 125q0 66-25 124.5t-68.5 102Q743-210 684.5-185T560-160Z"/></svg>' + "\
              Probefahrt vereinbaren\
            </a>\
          </div>"
      )
      + "\
      </div >";
  }


  const filterVendors = (newVendors, fitBounds = false) => {
    if (newVendors.length == 0) return;
    if (filter.lat == 0 && filter.lng == 0) {
      setFilteredVendors([]);
      return;
    }

    let max_distance = 1.0;
    let vendorsWithDistance = [];
    for (let i = 0; i < newVendors.length; i++) {
      const distance = Math.sqrt(
        Math.pow(newVendors[i].lat - filter.lat, 2) +
        Math.pow(newVendors[i].lng - filter.lng, 2)
      );
      const distanceKm = distance * 111.32;
      let distanceDescription = '';
      if (distanceKm < 10) {
        distanceDescription = 'in der Nähe ' + (filter.locationName ? 'von ' + filter.locationName : '');
      } else {
        distanceDescription = 'ca. ' + Math.round(distanceKm / 10) * 10 + ' km Luftlinie ' + (filter.locationName ? 'von ' + filter.locationName : '') + ' entfernt';
      }
      vendorsWithDistance.push({
        ...newVendors[i],
        distance,
        distanceDescription
      });
    }
    let newFilteredVendors = vendorsWithDistance.filter(vendor => {
      return vendor.distance < max_distance;
    });
    while (newFilteredVendors.length == 0) {
      max_distance += 0.3;
      newFilteredVendors = vendorsWithDistance.filter(vendor => {
        return vendor.distance < max_distance;
      });
    }
    // order vendors by distance
    newFilteredVendors.sort((a, b) => {
      return a.distance - b.distance;
    });

    setFilteredVendors(newFilteredVendors);
    Object.keys(markers).forEach((vendorId) => {
      // if vendor is in filtered vendors, highlight marker
      if (newFilteredVendors.find(vendor => vendor.id == vendorId)) {
        markers[vendorId].addClassName('highlighted');
      } else {
        markers[vendorId].removeClassName('highlighted');
      }
    });
    if (!fitBounds) return;
    map.current.flyTo({
      center: [filter.lng, filter.lat],
    });
    const filteredVendorsBoundingBox = new mapboxgl.LngLatBounds();
    newFilteredVendors.forEach(vendor => {
      filteredVendorsBoundingBox.extend([vendor.lng, vendor.lat]);
    });
    map.current.fitBounds(filteredVendorsBoundingBox, { padding: 100 });
  }


  return (
    <>
      <AddressSearch onAddressSelect={(address => {
        setFilter({
          locationName: address.name,
          lat: parseFloat(address.lat),
          lng: parseFloat(address.lon)
        });
        setLat(parseFloat(address.lat));
        setLng(parseFloat(address.lon));
        if (searchCenterMarker) {
          searchCenterMarker.remove();
        }
        const centerMarkerElement = document.createElement('div');
        centerMarkerElement.className = 'search-center-marker';

        const newCenterMarker = new mapboxgl.Marker({ element: centerMarkerElement, anchor: 'center' })
          .setLngLat([address.lon, address.lat])
          .addTo(map.current);
        setSearchCenterMarker(newCenterMarker);
        setZoom(16);
      })} />
      <div ref={mapContainer} className="vendor-map-container" />
      {isLoading ? <div className='loading'>Lade Händler...</div> : null}
      {filteredVendors.length > 0 && <>
        <h3 class="results-headline">Händler in der Nähe von {filter.locationName}</h3>
        <div className="vendors">
          {filteredVendors.map((vendor, index) => (
            <Vendor vendor={vendor} classification={classification} key={vendor.id} />
          ))}
        </div>
      </>}
      {filteredVendors.length == 0 && filter.lat > 0 && <div className='no-vendors'>Keine Händler in der Nähe gefunden.</div>}
    </>
  );
}
